import React, { Fragment } from "react";
import { Progress } from "reactstrap";
import { useLocation } from "react-router-dom";
import { publicRequest } from "../auth/requestMethods"
import SweetAlert from 'sweetalert2'
import { Alert } from "reactstrap";

const ResetPwd = ({ history }) => {
  const path = useLocation().pathname.split("/")[2];
  const [password, setPassword] = React.useState({ '1': "", '2': "" });
  const [error, setError] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [passwordMeter, setPasswordMeter] = React.useState({
    text: "Weak",
    percent: 1,
    class: "danger",
  });

  function passwordOnChange(e) {
    checkStrength(e.target.value);
    setPassword({ ...password, [e.target.name]: e.target.value });
  }

  function checkStrength(password) {
    let percent = 0;

    //If password contains both lower and uppercase characters
    if (password.match(/([a-z].*[A-Z])|([A-Z].*[a-z])/)) percent += 25
    //If it has numbers and characters
    if (password.match(/([0-9])/)) percent += 25
    //If it has one special character
    if (password.match(/([!,%,&,@,#,$,^,*,?,_,~])/)) percent += 20
    //If password is greater than 7
    if (password.length > 7) percent += 30

    if (percent < 60)
      setPasswordMeter({
        text: "Weak",
        percent,
        class: "danger",
      });
    else if (percent < 100)
      setPasswordMeter({
        text: "Medium",
        percent: 60,
        class: "warning",
      });

    else if (percent === 100)
      setPasswordMeter({
        text: "Strong",
        percent,
        class: "success",
      });
  }

  function formSubmit(e) {
    e.preventDefault();
    error && setError("")
    setLoading(true)
    publicRequest().post(`/users/reset-password/${path}`, { password: password[1] })
      .then(res => {
        SweetAlert.fire({ title: "Successful!", text: "Password has been reset.", icon: "success" }).then(() => {
          history.push(`${process.env.PUBLIC_URL}/`)
        }).catch(() => history.push(`${process.env.PUBLIC_URL}/`))
      })
      .catch(({ response }) => {
        setError(response.data.message);
        setLoading(false);
      })
    // submit 
  }

  return (
    <Fragment>
      <div className="page-wrapper">
        <div className="container-fluid">
          <div className="authentication-main">
            <div className="row">
              <div className="col-md-12 p-0">
                <div className="auth-innerright">
                  <div className="authentication-box">
                    <div className="text-center">
                      {/* <img   width="350" src={`${process.env.PUBLIC_URL}/full-logo.jpg`} alt="" /> */}
                    </div>
                    <div className="card mt-4 p-4">
                      <form className="theme-form" onSubmit={formSubmit}>
                        <h5 className="f-16 mb-3 f-w-600">Reset Password</h5>
                        <div className="form-group">
                          <label className="col-form-label">*New Password</label>
                          <input
                            className="form-control"
                            type="password"
                            placeholder="*****"
                            value={password["1"]}
                            onChange={passwordOnChange}
                            name='1'
                          />
                        </div>
                        <div className="form-group">
                          <label className="col-form-label">
                            *Confirm Password
                          </label>
                          <input
                            className="form-control"
                            type="password"
                            placeholder="*****"
                            value={password["2"]}
                            onChange={passwordOnChange}
                            name='2'
                          />
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            width: "100%",
                          }}
                        >
                          <Progress
                            className="col-md-8"
                            color={passwordMeter.class}
                            value={passwordMeter.percent}
                          />
                          <p
                            className={`col-form-label txt-${passwordMeter.class}`}
                          >{`${passwordMeter.text}`}</p>
                        </div>
                        <p className="col-form-label mb-2 txt-info">
                          Minimum of 7 characters
                        </p>
                        <Alert isOpen={!!error} color="danger dark text-center">{error}</Alert>
                        {loading && (
                          <div className="loader d-flex justify-content-center mb-4">
                            <div className="line bg-primary"></div>
                            <div className="line bg-primary"></div>
                            <div className="line bg-primary"></div>
                            <div className="line bg-primary"></div>
                          </div>
                        )}
                        <div className="form-group form-row mb-0">
                          <button
                            disabled={password['1'].length >= 7 ? password['1'] === password['2'] ? false : true : true}
                            className="btn btn-primary col-12"
                            type="submit"
                          >
                            Reset
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <!-- Reset Password page end--> */}
        </div>
      </div>
    </Fragment>
  );
};

export default ResetPwd;
